import React from 'react'
import { quoteBlockNestedClasses } from '../../../../../../utils/style'
import { getClassName } from '../../../../../../utils/utils'
import { QuoteBlockNested } from '../../../blocksState'
import { useInView } from '../../../../../hooks/useInView'

export type QuoteBlockNestedStyle = Partial<{
  blockClassName: string
  inviewClassName: string
  innerClassName: string
  contentClassName: string
  quoteClassName: string
  quoteTextClassName: string
  authorClassName: string
}>

export const QuoteBlockNestedLayout = (props: QuoteBlockNested) => {
  const { author, inview, index, text } = props
  const classes = quoteBlockNestedClasses
  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("QuoteBlockNestedLayout inView:", inview),
    !inview?.triggerOnce
  )
  return (
    <figure
      key={`block-${index}`}
      id={`io-${index}`}
      ref={ref}
      className={getClassName(classes, 'blockClassName', 'container') + ' ' + (inView ? getClassName(classes, 'inviewClassName', 'inview') : '')}
    >
      <div className={getClassName(classes, 'innerClassName', 'py-3')}>
        <div className={getClassName(classes, 'contentClassName', 'text-center')}>
          {text && (
            <blockquote className={getClassName(classes, 'quoteClassName', '')}>
              <p className={getClassName(classes, 'quoteTextClassName', 'h4')}>{text}</p>
            </blockquote>
          )}

          {author && (
            <figcaption className={getClassName(classes, 'authorClassName', 'text-muted')}>
              <cite>{author}</cite>
            </figcaption>
          )}
        </div>
      </div>
    </figure>
  )
}
